import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate, useLocation, useOutletContext } from "react-router-dom";
import { get_summary_report, init_simulation } from "../services/api";
import { rootRoute } from "../../../config";
import { errorMsg } from "../../../helper/helpers";
import info from "../assets/info.png";
import General_feedback_active from "../assets/General_feedback_active.png";
import General_feedback_deactive from "../assets/General_feedback_deactive.png";
import Financial_analysis_active from "../assets/Finacial_analysis_active.png";
import Financial_analysis_deactive from "../assets/Financial_analysis_deactive.png";
import order_analysis_active from "../assets/order_analysis_active.png";
import order_analysis_deactive from "../assets/order_analysis_deactive.png";
import Button from "../../common/Button";
import leftArrow from "../assets/leftArrow.png";
import rightArrow from "../assets/rightArrow.png";
import prevArrow from "../assets/prevArrow.png";
import ScmModuleStyle from "../styles/scm.module.css";
import GraphPerQuarter from "./ExpenseBreakGraph.js";
import GraphProcurementBreakdown from "./financialAnalysisGraph.js";
import OrderBySupplierGraph from "./OrderBySupplierGraph";
import pluralize from 'pluralize';
// import RevenueGraph from "./RevenueGraph";
// import InventoryGraph from "./InventoryGraph";

const Summary = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);

  const [summaryReports, setSummaryReports] = useState({});
  const [simulationDetailSummary, setSimulationDetailSummary] = useState([]);
  const [attempt, setAttempt] = useState(queryParams.get("attempt"));
  const [pagination, setPagination] = useState({ prev: false, next: false });
  const [
    simPopup,
    setSimPopup,
    isOverlay,
    setIsOverlay,
    headerPopup,
    setHeaderPopup,
    isArtifacts,
    setIsArtifacts,
    plPopup,
    setPlPopup,
    ulPopup,
    setUlPopup,
    simPrgPopup,
    setSimPrgPopup,
    skipWalkThruPopups,
    isPopupShown,
    setIsPopupShown,
    accordionPopup,
    setAccordionPopup,
    simObj,
    setSimObj,
    getMonth,
    toggleSimulation,
    setToggleSimulation,
    startOverSimulation,
    isLoader,
    setIsLoader,
    setAriaProperty,
    check_Location,
    setError,
  ] = useOutletContext();
  const [isActive, setIsActive] = useState("generalFeedback");
  const [executioninstanceid, setExecutioninstanceid] = useState("");
  const [page, setPage] = useState(1);
  const [pageHeight, setPageHeight] = useState("");
  const summaryBtnStyle = {
    color: "white",
    borderRadius: "40px",
    margin: "0px",
    padding: "16px 55px",
    fontSize: "16px",
  };
  const noOfRatings = [1, 2, 3, 4, 5];
  const starRating = Number(summaryReports?.FinancialAnalysis?.starRating);
  const TargetSR = Number(summaryReports?.FinancialAnalysis?.targetStarRating);

  let session_id = queryParams.get("sid");
  let resource_id = queryParams.get("resid");
  let course_id = queryParams.get("cid");
  let user_id = queryParams.get("userid");
  let attempt_id = queryParams.get("attempt");
  let role = queryParams.get("role");

  // const formatNum = (number) => {
  //   let formattedNumber = number?.toString();
  //   formattedNumber = formattedNumber?.includes(".")
  //     ? formattedNumber?.replace(/\.?0*$/, "")
  //     : formattedNumber;
  //   return formattedNumber;
  // };
  const formatNum = (num) => {
    return num?.toLocaleString("en-US", { style: "decimal" });
  };
  const checkNum = (num) => {
    return num < 0
      ? `-$${Math?.abs(num)?.toLocaleString(undefined, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })}`
      : `$${num?.toLocaleString(undefined, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })}`;
  };
  const handleSetActive = (e) => {
    const generalFeedbackOffset =
      document.getElementById(`${ScmModuleStyle.generalFeedback}`).offsetTop -
      20;
    const financialAnalysisOffset =
      document.getElementById(`${ScmModuleStyle.financialAnalysis}`).offsetTop -
      25;
    const decisionAnalysisOffset =
      document.getElementById(`${ScmModuleStyle.decisionAnalysis}`).offsetTop -
      25;

      if (e.type === "click") {
        if (e.currentTarget.classList.contains("generalFeedbackParent")) {
          document
            .getElementById(`${ScmModuleStyle.generalFeedback}`)
            .querySelector("h2").tabIndex = -1;
          document
            .getElementById(`${ScmModuleStyle.generalFeedback}`)
            .querySelector("h2")
            .focus();
          if (
            document.querySelector(`.${ScmModuleStyle["summary-content-box"]}`) !=
            null
          ) {
            document.querySelector(
              `.${ScmModuleStyle["summary-content-box"]}`
            ).scrollTop = generalFeedbackOffset - 20;
          }
        } else if (e.currentTarget.classList.contains("decisionAnalysisParent")) {
          document.getElementById(`${ScmModuleStyle.decisionAnalysis}`).querySelector("h2").tabIndex = -1;
          document.getElementById(`${ScmModuleStyle.decisionAnalysis}`).querySelector("h2").focus();
          if (
            document.querySelector(`.${ScmModuleStyle["summary-content-box"]}`) !=
            null
          ) {
            document.querySelector(
              `.${ScmModuleStyle["summary-content-box"]}`
            ).scrollTop = decisionAnalysisOffset - 0;
          }
        } else if (
          e.currentTarget.classList.contains("financialAnalysisParent")
        ) {
          document.getElementById(`${ScmModuleStyle.financialAnalysis}`).querySelector("h2").tabIndex = -1;
          document.getElementById(`${ScmModuleStyle.financialAnalysis}`).querySelector("h2").focus();
          if (
            document.querySelector(`.${ScmModuleStyle["summary-content-box"]}`) !=
            null
          ) {
            document.querySelector(
              `.${ScmModuleStyle["summary-content-box"]}`
            ).scrollTop = financialAnalysisOffset - 0;
          }
        }
      }
    const scrollPosition = e.currentTarget.scrollTop;

    if (
      scrollPosition >= generalFeedbackOffset &&
      scrollPosition < financialAnalysisOffset
    ) {
      document.querySelector(`.generalFeedbackParent `).blur();
      setIsActive("generalFeedback");
    } else if (
      scrollPosition >= financialAnalysisOffset &&
      scrollPosition < decisionAnalysisOffset
    ) {
      document.querySelector(`.financialAnalysisParent `).blur();
      setIsActive("financialAnalysis");
    } else if (scrollPosition >= decisionAnalysisOffset) {
      document.querySelector(`.decisionAnalysisParent `).blur();
      setIsActive("decisionAnalysis");
    }
  };
  const navigateToSimulation = () => {
    navigate(rootRoute + "/scm/simulation");
  };
  const handlePopupExitSim = (e) => {
    window.close();
  };
  const initSummary = () => {
    simObj?.status != "COMPLETED" &&
      attempt == undefined &&
      user_id == undefined &&
      navigate(`${rootRoute}/scm/summary`);
    window.$("html, body").animate({ scrollTop: 0 }, 100);
  };
  const backToSimulationList = () => {
    setIsLoader(true);
    if (role == "student") {
      navigate(rootRoute + `/scm/studentreview?${queryParams}`);
    } else {
      navigate(rootRoute + `/scm/instructorreview?${queryParams}`);
    }
  };
  const getNextAttempt = () => {
    setIsLoader(true);
    let index = simulationDetailSummary?.findIndex(
      (sdObj) => sdObj.attemptno == attempt
    );
    let currSdSObj = simulationDetailSummary[index + 1];
    if (currSdSObj != undefined) {
      setAttempt(currSdSObj.attemptno);
      queryParams.set("attempt", currSdSObj.attemptno);
      setExecutioninstanceid(currSdSObj?.executioninstanceid);
      simulationDetailSummary[index + 2] != undefined
        ? setPagination({ prev: true, next: false })
        : setPagination({ prev: false, next: true });
    } else {
      setPagination({ prev: false, next: true });
      setIsLoader(false);
    }
  };
  const getPrevAttempt = () => {
    setIsLoader(true);
    let index = simulationDetailSummary?.findIndex(
      (sdObj) => sdObj.attemptno == attempt
    );
    let currSdSObj = simulationDetailSummary[index - 1];
    if (currSdSObj != undefined) {
      setAttempt(currSdSObj.attemptno);
      queryParams.set("attempt", currSdSObj.attemptno);
      setExecutioninstanceid(currSdSObj?.executioninstanceid);
      simulationDetailSummary[index - 2] != undefined
        ? setPagination({ prev: false, next: false })
        : setPagination({ prev: true, next: false });
    } else {
      setPagination({ prev: true, next: false });
      setIsLoader(false);
    }
  };
  const OnLoadPagination = () => {
    let lastObjIndex = simulationDetailSummary?.length - 1;
    let firstObjIndex = 0;
    let currentIndex = simulationDetailSummary?.findIndex(
      (sdObj) => sdObj.attemptno == attempt
    );
    currentIndex == lastObjIndex && setPagination({ prev: false, next: true });
    currentIndex == firstObjIndex && setPagination({ prev: true, next: false });
    if (currentIndex != lastObjIndex && currentIndex != firstObjIndex) {
      setPagination({ prev: false, next: false });
    }
  };
  const getSimulationDetailSummary = () => {
    setSimulationDetailSummary(
      attempt != undefined && user_id != undefined
        ? simObj?.simulationdetails
        : []
    );
    setIsLoader(false);
  };
  const updateExcutionInstanceId = () => {
    if (attempt != undefined && user_id != undefined) {
      setExecutioninstanceid(
        simulationDetailSummary?.filter(
          (sdObj) => sdObj.attemptno == attempt
        )[0]?.executioninstanceid
      );
    } else {
      setExecutioninstanceid(simObj?.executioninstanceid);
    }
  };
  const getSummaryReport = () => {
    (simObj?.sessionid != undefined || session_id != undefined) &&
      executioninstanceid != undefined &&
      executioninstanceid.length > 0 &&
      get_summary_report(simObj?.sessionid || session_id, executioninstanceid)
        .then((response) => {
          if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
            setError(response?.data)
        }
        else{
          setSummaryReports(response?.data);
          //console.log(response.data)
          OnLoadPagination();
          setIsLoader(false);
        }
        })
        .catch((error) => {
          // setError(errorMsg);
          setError({"id":"00000","msg":errorMsg})
          console.log(error);
        });
  };
  const generalClickHandler = (e) => {
    if (window.innerWidth > 570) {
      e.preventDefault();
      document.querySelector(".generalFeedbackParent").click();
      e.stopPropagation();
    }
    return 0;
  };
  const financialClickHandler = (e) => {
    if (window.innerWidth > 570) {
      e.preventDefault();
      document.querySelector(".financialAnalysisParent").click();
      e.stopPropagation();
    }
    return 0;
  };
  const decisionClickHandler = (e) => {
    if (window.innerWidth > 570) {
      e.preventDefault();
      document.querySelector(".decisionAnalysisParent").click();
      e.stopPropagation();
    }
    return 0;
  };
  const getUserData = (data,num) => {
    if(num == 1){
      return pluralize(data,1)
    }
    else{
      return pluralize(data,2)
    }
  }
  useEffect(() => {
    setIsLoader(true);
    if (session_id != "" && simObj?.laststate == undefined) {
      //&& queryParams.get("sid") == undefined
      //setError(null);
      init_simulation(session_id)
        .then(function (response) {
          if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
            setError(response?.data)
        }
        else{
          // console.log(response.data);
          setSimObj(
            Object.assign(response?.data, {
              simulationdetails: simObj?.simulationdetails,
            })
          );
          setError(null);
        }
        })
        .catch((error) => {
          // setError(errorMsg);
          setError({"id":"00000","msg":errorMsg})
        });
    }
    setIsOverlay(false);
  }, []);
  useEffect(() => {
    updateExcutionInstanceId();
  }, [simulationDetailSummary]);
  useEffect(() => {
    getSimulationDetailSummary();
  }, [attempt]);
  useEffect(() => {
    getSummaryReport();
  }, [executioninstanceid]);
  useEffect(() => {
    if (document.querySelector("header.header") != null) {
      document.querySelector("header.header").style.display = "none";
      document.querySelector(".App .row").style.minHeight = "auto";
    }
    setIsLoader(true);
    initSummary();
    setAttempt(queryParams.get("attempt"));
    document.querySelector(
      `.${ScmModuleStyle["summary-container"]} header.header h1`
    ).tabIndex = -1;
    document
      .querySelector(`.${ScmModuleStyle["summary-container"]} header.header h1`)
      .focus();
    const summaryPageHeight =
      window.innerHeight -
      document.querySelector(
        `.${ScmModuleStyle["summary-container"]} header.header`
      ).clientHeight -
      document.getElementsByClassName(`${ScmModuleStyle["summary-footer"]}`)[0]
        .clientHeight -
      document.querySelector(`.footer`).clientHeight;
    setPageHeight(summaryPageHeight - 1);
    document.title = "Supply Chain Management | Summary";

    if (attempt != undefined && user_id != undefined) {
      // if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
      //   document.querySelector("footer.footer .footer-nav .footer-links").style.display = "none";
      // }
      // if (document.querySelector("footer.footer .container") != null) {
      //   document.querySelector("footer.footer .container").style.justifyContent = "center";
      // }
      if (
        document.querySelector("footer.footer .footer-nav .footer-links") !=
        null
      ) {
        document.querySelector(
          "footer.footer .footer-nav .footer-links"
        ).firstChild.style.display = "none";
      }
    }

    return () => {
      if (document.querySelector("header.header") != null) {
        document.querySelector("header.header").style.display = "block";
        document.querySelector(".App .row").style.minHeight = "100vh";
      }

      if (attempt != undefined && user_id != undefined) {
        if (
          document.querySelector("footer.footer .footer-nav .footer-links") !=
          null
        ) {
          document.querySelector(
            "footer.footer .footer-nav .footer-links"
          ).style.display = "block";
        }
        if (document.querySelector("footer.footer .container") != null) {
          document.querySelector(
            "footer.footer .container"
          ).style.justifyContent = "space-between";
        }
      }
    };
  }, [simObj?.sessionid || session_id]);

  return (
    <motion.div
      className={`${ScmModuleStyle["summary-container"]}`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <header className={`header ${ScmModuleStyle.header}`}>
        <div className={`container ${ScmModuleStyle.container}`}>
          <div className={`${ScmModuleStyle["icon-header-box"]}`}>
            {attempt != undefined && user_id != undefined && (
              <button onClick={backToSimulationList}>
                <img src={prevArrow} />
              </button>
            )}
            <h1
              className={`ui header title ${ScmModuleStyle.ui} ${ScmModuleStyle.header} ${ScmModuleStyle.title}`}
            >
              {attempt != undefined
                ? `Summary Report(Attempt ${attempt})`
                : "The year is over! Review your results below."}
            </h1>
          </div>
          {attempt != undefined &&
            user_id != undefined &&
            simulationDetailSummary?.length != 1 && (
              <div className={`${ScmModuleStyle["pagination-icons"]}`}>
                <button disabled={pagination.prev} onClick={getPrevAttempt}>
                  <img src={leftArrow} />
                </button>
                <button disabled={pagination.next} onClick={getNextAttempt}>
                  <img src={rightArrow} />
                </button>
              </div>
            )}
        </div>
      </header>
      <div
        className={`ui stackable two column grid ${ScmModuleStyle.ui} ${ScmModuleStyle.stackable} ${ScmModuleStyle.column} ${ScmModuleStyle.grid} ${ScmModuleStyle["summary-content"]} `}
      >
        <div
          className={`column ${ScmModuleStyle.column} ${ScmModuleStyle["navigation-tab"]}`}
        >
          <ul
            className={`ui link list ${ScmModuleStyle.ui} ${ScmModuleStyle.link} ${ScmModuleStyle.list}`}
          >
            <li
              className={`item generalFeedbackParent ${
                ScmModuleStyle["item"]
              } ${
                isActive === "generalFeedback"
                  ? `${ScmModuleStyle["active"]}`
                  : ""
              }`}
              onClick={(e) => {
                handleSetActive(e);
                setIsActive("generalFeedback");
                // e.target.focus();
                e.stopPropagation();
              }}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  e.target.click();
                }
              }}
              // tabIndex={`${isActive === "generalFeedback" ? -1 : 0}`}
              tabIndex={0}
            >
              <a
                href={`#${ScmModuleStyle.generalFeedback}`}
                onClick={generalClickHandler}
                tabIndex={-1}
              >
                <img
                  src={
                    isActive === "generalFeedback"
                      ? General_feedback_active
                      : General_feedback_deactive
                  }
                  alt=""
                />
                <span>GENERAL FEEDBACK</span>
              </a>
            </li>
            <li
              className={`item financialAnalysisParent ${
                ScmModuleStyle["item"]
              } ${
                isActive === "financialAnalysis"
                  ? `${ScmModuleStyle["active"]}`
                  : ""
              }`}
              onClick={(e) => {
                handleSetActive(e);
                setIsActive("financialAnalysis");
                // e.target.focus();
                e.stopPropagation();
              }}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  e.target.click();
                }
              }}
              // tabIndex={`${isActive === "financialAnalysis" ? -1 : 0}`}
              tabIndex={0}
            >
              <a
                href={`#${ScmModuleStyle.financialAnalysis}`}
                onClick={financialClickHandler}
                tabIndex={-1}
              >
                <img
                  src={
                    isActive === "financialAnalysis"
                      ? Financial_analysis_active
                      : Financial_analysis_deactive
                  }
                  alt=""
                />
                <span>FINANCIAL ANALYSIS</span>
              </a>
            </li>
            <li
              className={`item decisionAnalysisParent ${
                ScmModuleStyle["item"]
              } ${
                isActive === "decisionAnalysis"
                  ? `${ScmModuleStyle["active"]}`
                  : ""
              }`}
              onClick={(e) => {
                handleSetActive(e);
                setIsActive("decisionAnalysis");
                // e.target.focus();
              }}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  e.target.click();
                }
              }}
              // tabIndex={`${isActive === "decisionAnalysis" ? -1 : 0}`}
              tabIndex={0}
            >
              <a
                href={`#${ScmModuleStyle.decisionAnalysis}`}
                onClick={decisionClickHandler}
                tabIndex={-1}
              >
                <img
                  src={
                    isActive === "decisionAnalysis"
                      ? order_analysis_active
                      : order_analysis_deactive
                  }
                  alt=""
                />
                <span>DECISION ANALYSIS</span>
              </a>
            </li>
          </ul>
        </div>
        <div
          className={`column ${ScmModuleStyle.column} ${ScmModuleStyle["summary-content-box"]} `}
          onWheel={handleSetActive}
          style={{ height: pageHeight + "px" }}
        >
          <div
            className={`${ScmModuleStyle.section}`}
            id={`${ScmModuleStyle.generalFeedback}`}
            style={{ marginTop: "0px" }}
          >
            <h2>General Feedback</h2>
            <table
              className={`ui unstackable table ${ScmModuleStyle.ui} ${ScmModuleStyle.unstackable} ${ScmModuleStyle.table}`}
            >
              <thead>
                <tr>
                  <th id="pMetric"
                    scope="col"
                    className={`four wide ${ScmModuleStyle.four} ${ScmModuleStyle.wide}`}
                  >
                    Performance Metric
                  </th>
                  {summaryReports?.GeneralFeedback?.last_totalComponent1Cost !=
                    "NA" ? (
                    <th id="prevAttempt"
                      scope="col"
                      className={`four wide right aligned ${ScmModuleStyle.four} ${ScmModuleStyle.wide} ${ScmModuleStyle.right} ${ScmModuleStyle.aligned}`}
                    >
                      Previous Attempt
                    </th>
                  ) : null }
                  <th id="currAttempt"
                    scope="col"
                    className={`four wide right aligned ${ScmModuleStyle.four} ${ScmModuleStyle.wide} ${ScmModuleStyle.right} ${ScmModuleStyle.aligned}`}
                  >
                    Current Attempt
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th id="tProcCostRBgt"
                    colSpan={summaryReports?.GeneralFeedback != undefined && summaryReports?.GeneralFeedback?.last_totalComponent1Cost !== "NA" ? 3 : 2 }
                    className={`${ScmModuleStyle["row-heading"]}`}
                  >
                    Total Procurement Cost and Remaining Budget
                  </th>
                </tr>
                <tr className={`${ScmModuleStyle["indent-row"]}`}>
                  <th id="tOdrCostSk1" headers="tProcCostRBgt"
                    className={`eight wide ${ScmModuleStyle.eight} ${ScmModuleStyle.wide}`}
                  >
                    Total order cost for SKU1
                  </th>
                  {summaryReports?.GeneralFeedback?.last_totalComponent1Cost !=
                    "NA" ? (
                    <td headers="tProcCostRBgt tOdrCostSk1 prevAttempt"
                      className={`four wide right aligned ${ScmModuleStyle.four} ${ScmModuleStyle.wide} ${ScmModuleStyle.right} ${ScmModuleStyle.aligned}`}
                    >
                      {checkNum(
                        Number(
                          summaryReports?.GeneralFeedback
                            ?.last_totalComponent1Cost
                        )
                      )}
                    </td>
                  ) : null }
                  <td headers="tProcCostRBgt tOdrCostSk1 currAttempt"
                    className={`four wide right aligned ${ScmModuleStyle.four} ${ScmModuleStyle.wide} ${ScmModuleStyle.right} ${ScmModuleStyle.aligned}`}
                  >
                    {checkNum(
                      Number(
                        summaryReports?.GeneralFeedback?.totalComponent1Cost
                      )
                    )}
                  </td>
                </tr>
                <tr className={`${ScmModuleStyle["indent-row"]}`}>
                  <th id="tOdrCostSk2" headers="tProcCostRBgt"
                    className={`eight wide ${ScmModuleStyle.eight} ${ScmModuleStyle.wide}`}
                  >
                    Total order cost for SKU2
                  </th>
                  {summaryReports?.GeneralFeedback?.last_totalComponent2Cost !=
                    "NA" ? (
                    <td headers="tProcCostRBgt tOdrCostSk2 prevAttempt"
                      className={`four wide right aligned ${ScmModuleStyle.four} ${ScmModuleStyle.wide} ${ScmModuleStyle.right} ${ScmModuleStyle.aligned}`}
                    >
                      {checkNum(
                        Number(
                          summaryReports?.GeneralFeedback
                            ?.last_totalComponent2Cost
                        )
                      )}
                    </td>
                  ) : null }
                  <td headers="tProcCostRBgt tOdrCostSk2 currAttempt"
                    className={`four wide right aligned ${ScmModuleStyle.four} ${ScmModuleStyle.wide} ${ScmModuleStyle.right} ${ScmModuleStyle.aligned}`}
                  >
                    {checkNum(
                      Number(
                        summaryReports?.GeneralFeedback?.totalComponent2Cost
                      )
                    )}
                  </td>
                </tr>
                <tr className={`${ScmModuleStyle["indent-row"]}`}>
                  <th id="tBidCost" headers="tProcCostRBgt"
                    className={`eight wide ${ScmModuleStyle.eight} ${ScmModuleStyle.wide}`}
                  >
                    Total Bid Cost
                  </th>
                  {summaryReports?.GeneralFeedback?.last_totalBidRequestCost !=
                    "NA" ? (
                    <td headers="tProcCostRBgt tBidCost prevAttempt"
                      className={`four wide right aligned ${ScmModuleStyle.four} ${ScmModuleStyle.wide} ${ScmModuleStyle.right} ${ScmModuleStyle.aligned}`}
                    >
                      {checkNum(
                        Number(
                          summaryReports?.GeneralFeedback
                            ?.last_totalBidRequestCost
                        )
                      )}
                    </td>
                  ) : null }
                  <td headers="tProcCostRBgt tBidCost currAttempt"
                    className={`four wide right aligned ${ScmModuleStyle.four} ${ScmModuleStyle.wide} ${ScmModuleStyle.right} ${ScmModuleStyle.aligned}`}
                  >
                    {checkNum(
                      Number(
                        summaryReports?.GeneralFeedback?.totalBidRequestCost
                      )
                    )}
                  </td>
                </tr>
                <tr className={`${ScmModuleStyle["indent-row"]}`}>
                  <th id="tProcCost" headers="tProcCostRBgt"
                    className={`eight wide ${ScmModuleStyle.eight} ${ScmModuleStyle.wide}`}
                  >
                    Total Procurement Cost
                  </th>
                  {summaryReports?.GeneralFeedback?.last_totalProcurementCost !=
                    "NA" ? (
                    <td headers="tProcCostRBgt tProcCost prevAttempt"
                      className={`four wide right aligned ${ScmModuleStyle.four} ${ScmModuleStyle.wide} ${ScmModuleStyle.right} ${ScmModuleStyle.aligned}`}
                    >
                      {checkNum(
                        Number(
                          summaryReports?.GeneralFeedback
                            ?.last_totalProcurementCost
                        )
                      )}
                    </td>
                  ) : null}
                  <td headers="tProcCostRBgt tProcCost currAttempt"
                    className={`four wide right aligned ${ScmModuleStyle.four} ${ScmModuleStyle.wide} ${ScmModuleStyle.right} ${ScmModuleStyle.aligned}`}
                  >
                    {checkNum(
                      Number(
                        summaryReports?.GeneralFeedback?.totalProcurementCost
                      )
                    )}
                  </td>
                </tr>
                <tr className={`${ScmModuleStyle["indent-row"]}`}>
                  <th id="rBdgt" headers="tProcCostRBgt"
                    className={`eight wide ${ScmModuleStyle.eight} ${ScmModuleStyle.wide}`}
                  >
                    Remaining Budget
                  </th>
                  {summaryReports?.GeneralFeedback?.last_remainingBudget !=
                    "NA" ? (
                    <td headers="tProcCostRBgt rBdgt prevAttempt"
                      className={`four wide right aligned ${ScmModuleStyle.four} ${ScmModuleStyle.wide} ${ScmModuleStyle.right} ${ScmModuleStyle.aligned}`}
                    >
                      {checkNum(
                        summaryReports?.GeneralFeedback?.last_remainingBudget
                      )}
                    </td>
                  ) : null }
                  <td headers="tProcCostRBgt rBdgt currAttempt"
                    className={`four wide right aligned ${ScmModuleStyle.four} ${ScmModuleStyle.wide} ${ScmModuleStyle.right} ${ScmModuleStyle.aligned}`}
                  >
                    {checkNum(summaryReports?.GeneralFeedback?.remainingBudget)}
                  </td>
                </tr>
                <tr>
                  <td className={`${ScmModuleStyle["text-td"]}`} colSpan={summaryReports?.GeneralFeedback?.last_totalComponent1Cost !== "NA" ? 3 : 2 }>
                   {summaryReports?.GeneralFeedback?.procurementCostVedict}
                  </td>
                </tr>
                <tr>
                  <th id="cProcManuftr"
                    colSpan={summaryReports?.GeneralFeedback != undefined && summaryReports?.GeneralFeedback?.last_totalComponent1Cost !== "NA" ? 3 : 2 }
                    className={`${ScmModuleStyle["row-heading"]}`}
                  >Components Procured and {(summaryReports?.userData && summaryReports?.userData!="") ? getUserData(summaryReports?.userData,2).charAt(0).toUpperCase() + getUserData(summaryReports?.userData,2).slice(1) : "Gizmos"} Manufactured
                  </th>
                </tr>
                <tr className={`${ScmModuleStyle["indent-row"]}`}>
                  <th id="sku1COdr" headers="cProcManuftr"
                    className={`eight wide ${ScmModuleStyle.eight} ${ScmModuleStyle.wide}`}
                  >
                    No. of SKU1 Component Ordered
                  </th>
                  {summaryReports?.GeneralFeedback?.last_noOfCom1Procurred !=
                    "NA" ? (
                    <td headers="cProcManuftr sku1COdr prevAttempt"
                      className={`four wide right aligned ${ScmModuleStyle.four} ${ScmModuleStyle.wide} ${ScmModuleStyle.right} ${ScmModuleStyle.aligned}`}
                    >
                      {summaryReports?.GeneralFeedback?.last_noOfCom1Procurred}
                    </td>
                  ) : null }
                  <td headers="cProcManuftr sku1COdr currAttempt"
                    className={`four wide right aligned ${ScmModuleStyle.four} ${ScmModuleStyle.wide} ${ScmModuleStyle.right} ${ScmModuleStyle.aligned}`}
                  >
                    {summaryReports?.GeneralFeedback?.noOfCom1Procurred}
                  </td>
                </tr>
                <tr className={`${ScmModuleStyle["indent-row"]}`}>
                  <th id="sku2COdr" headers="cProcManuftr"
                    className={`eight wide ${ScmModuleStyle.eight} ${ScmModuleStyle.wide}`}
                  >
                    No. of SKU2 Component Ordered
                  </th>
                  {summaryReports?.GeneralFeedback?.last_noOfCom2Procurred !=
                    "NA" ? (
                    <td headers="cProcManuftr sku2COdr prevAttempt"
                      className={`four wide right aligned ${ScmModuleStyle.four} ${ScmModuleStyle.wide} ${ScmModuleStyle.right} ${ScmModuleStyle.aligned}`}
                    >
                      {summaryReports?.GeneralFeedback?.last_noOfCom2Procurred}
                    </td>
                  ) : null }
                  <td headers="cProcManuftr sku2COdr currAttempt"
                    className={`four wide right aligned ${ScmModuleStyle.four} ${ScmModuleStyle.wide} ${ScmModuleStyle.right} ${ScmModuleStyle.aligned}`}
                  >
                    {summaryReports?.GeneralFeedback?.noOfCom2Procurred}
                  </td>
                </tr>
                <tr className={`${ScmModuleStyle["indent-row"]}`}>
                  <th id="tPdctManuftr" headers="cProcManuftr"
                    className={`eight wide ${ScmModuleStyle.eight} ${ScmModuleStyle.wide}`}
                  >
                    Total no. of {(summaryReports?.userData && summaryReports?.userData!="") ? getUserData(summaryReports?.userData,2).charAt(0).toUpperCase() + getUserData(summaryReports?.userData,2).slice(1) : "Gizmos"} Manufactured
                  </th>
                  {summaryReports?.GeneralFeedback?.last_TotalGizmos !=
                    "NA" ? (
                    <td headers="cProcManuftr tPdctManuftr prevAttempt"
                      className={`four wide right aligned ${ScmModuleStyle.four} ${ScmModuleStyle.wide} ${ScmModuleStyle.right} ${ScmModuleStyle.aligned}`}
                    >
                      {summaryReports?.GeneralFeedback?.last_TotalGizmos}
                    </td>
                  ) : null }
                  <td headers="cProcManuftr tPdctManuftr currAttempt"
                    className={`four wide right aligned ${ScmModuleStyle.four} ${ScmModuleStyle.wide} ${ScmModuleStyle.right} ${ScmModuleStyle.aligned}`}
                  >
                    {summaryReports?.GeneralFeedback?.TotalGizmos}
                  </td>
                </tr>
                <tr>
                  <td className={`${ScmModuleStyle["text-td"]}`} colSpan={summaryReports?.GeneralFeedback?.last_totalComponent1Cost !== "NA" ? 3 : 2 }>
                    {(summaryReports?.GeneralFeedback?.gizmosManufacturedVedict.includes("gizmos")) ? summaryReports?.GeneralFeedback?.gizmosManufacturedVedict.replace("gizmos", pluralize(summaryReports?.userData,2)) : summaryReports?.GeneralFeedback?.gizmosManufacturedVedict}
                  </td>
                </tr>
                <tr>
                  <th id="cusMorl"
                    colSpan={summaryReports?.GeneralFeedback != undefined && summaryReports?.GeneralFeedback?.last_totalComponent1Cost !== "NA" ? 3 : 2 }
                    className={`${ScmModuleStyle["row-heading"]}`}>
                      Customer Morale
                  </th>
                </tr>
                {/* <tr className={`${ScmModuleStyle["indent-row"]}`}>
                  <td
                    // colSpan={2}
                    className={`four wide ${ScmModuleStyle.four} ${ScmModuleStyle.wide}`}
                  ></td>
                  {summaryReports?.GeneralFeedback?.last_CustomerMorals !=
                    "NA" ? (
                    <>
                      <td
                        className={`one wide ${ScmModuleStyle.one} ${ScmModuleStyle.wide}`}
                      >
                        Q1
                      </td>
                      <td
                        className={`one wide ${ScmModuleStyle.one} ${ScmModuleStyle.wide}`}
                      >
                        Q2
                      </td>
                      <td
                        className={`one wide ${ScmModuleStyle.one} ${ScmModuleStyle.wide}`}
                      >
                        Q3
                      </td>
                      <td
                        className={`one wide ${ScmModuleStyle.one} ${ScmModuleStyle.wide} ${ScmModuleStyle["border-right"]}`}
                      >
                        Q4
                      </td>
                    </>
                  ) : null }
                  <td
                    className={`one wide ${ScmModuleStyle.one} ${ScmModuleStyle.wide}`}
                  >
                    Q1
                  </td>
                  <td
                    className={`one wide ${ScmModuleStyle.one} ${ScmModuleStyle.wide}`}
                  >
                    Q2
                  </td>
                  <td
                    className={`one wide ${ScmModuleStyle.one} ${ScmModuleStyle.wide}`}
                  >
                    Q3
                  </td>
                  <td
                    className={`one wide ${ScmModuleStyle.one} ${ScmModuleStyle.wide}`}
                  >
                    Q4
                  </td>
                </tr>
                <tr className={`${ScmModuleStyle["indent-row"]}`}>
                  <th
                    // colSpan={2}
                    className={`four wide ${ScmModuleStyle.four} ${ScmModuleStyle.wide}`}
                  >
                    Morale Value
                  </th>
                  {summaryReports?.GeneralFeedback?.last_CustomerMorals !=
                    "NA" ? (
                    <>
                      <td
                        className={`one wide ${ScmModuleStyle.one} ${ScmModuleStyle.wide}`}
                      >
                        {
                          summaryReports?.GeneralFeedback?.last_CustomerMorals
                            ?.Q1
                        }
                      </td>
                      <td
                        className={`one wide ${ScmModuleStyle.one} ${ScmModuleStyle.wide}`}
                      >
                        {
                          summaryReports?.GeneralFeedback?.last_CustomerMorals
                            ?.Q2
                        }
                      </td>
                      <td
                        className={`one wide ${ScmModuleStyle.one} ${ScmModuleStyle.wide}`}
                      >
                        {
                          summaryReports?.GeneralFeedback?.last_CustomerMorals
                            ?.Q3
                        }
                      </td>
                      <td
                        className={`one wide ${ScmModuleStyle.one} ${ScmModuleStyle.wide} ${ScmModuleStyle["border-right"]}`}
                      >
                        {
                          summaryReports?.GeneralFeedback?.last_CustomerMorals
                            ?.Q4
                        }
                      </td>
                    </>
                  ) : null }
                  <td
                    className={`one wide ${ScmModuleStyle.one} ${ScmModuleStyle.wide}`}
                  >
                    {summaryReports?.GeneralFeedback?.CustomerMorals?.Q1}
                  </td>
                  <td
                    className={`one wide ${ScmModuleStyle.one} ${ScmModuleStyle.wide}`}
                  >
                    {summaryReports?.GeneralFeedback?.CustomerMorals?.Q2}
                  </td>
                  <td
                    className={`one wide ${ScmModuleStyle.one} ${ScmModuleStyle.wide}`}
                  >
                    {summaryReports?.GeneralFeedback?.CustomerMorals?.Q3}
                  </td>
                  <td
                    className={`one wide ${ScmModuleStyle.one} ${ScmModuleStyle.wide}`}
                  >
                    {summaryReports?.GeneralFeedback?.CustomerMorals?.Q4}
                  </td>
                </tr> */}

                <tr className={`${ScmModuleStyle["indent-row"]}`}>
                <td className={`${ScmModuleStyle["nested-td"]}`} colSpan={summaryReports?.GeneralFeedback != undefined && summaryReports?.GeneralFeedback?.last_totalComponent1Cost !== "NA" ? 3 : 2 }>
                  <table className={`${ScmModuleStyle["nested-table"]}`}>
                    <thead>
                      <tr className={ScmModuleStyle["indent-row"]}>
                        <th className={`four wide ${ScmModuleStyle.wide}`}>
                        </th>
                        {/* Add Q1-Q4 headers for each set */}
                        {summaryReports?.GeneralFeedback?.last_CustomerMorals !== "NA" ? (
                          <>
                            <th id="prevQ1" headers="prevAttempt" scope="col" className={`one wide ${ScmModuleStyle.wide}`}>
                              Q1
                            </th>
                            <th id="prevQ2" headers="prevAttempt" scope="col" className={`one wide ${ScmModuleStyle.wide}`}>
                              Q2
                            </th>
                            <th id="prevQ3" headers="prevAttempt" scope="col" className={`one wide ${ScmModuleStyle.wide}`}>
                              Q3
                            </th>
                            <th id="prevQ4" headers="prevAttempt" scope="col" className={`one wide ${ScmModuleStyle.wide} ${ScmModuleStyle["border-right"]}`}>
                              Q4
                            </th>
                          </>
                        ) : null }
                        <th id="currQ1" headers="currAttempt" scope="col" className={`one wide ${ScmModuleStyle.wide}`}>
                          Q1
                        </th>
                        <th id="currQ2" headers="currAttempt" scope="col" className={`one wide ${ScmModuleStyle.wide}`}>
                          Q2
                        </th>
                        <th id="currQ3" headers="currAttempt" scope="col" className={`one wide ${ScmModuleStyle.wide}`}>
                          Q3
                        </th>
                        <th id="currQ4" headers="currAttempt" scope="col" className={`one wide ${ScmModuleStyle.wide}`}>
                          Q4
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th headers="cusMorl" className={`four wide ${ScmModuleStyle.wide}`} scope="row" >
                          Morale Value
                        </th>
                        {summaryReports?.GeneralFeedback?.last_CustomerMorals !== "NA" ? (
                          <>
                            <td headers="prevQ1 prevAttempt" className={`one wide ${ScmModuleStyle.wide}`}>
                              {summaryReports?.GeneralFeedback?.last_CustomerMorals?.Q1}
                            </td>
                            <td headers="prevQ2 prevAttempt" className={`one wide ${ScmModuleStyle.wide}`}>
                              {summaryReports?.GeneralFeedback?.last_CustomerMorals?.Q2}
                            </td>
                            <td headers="prevQ3 prevAttempt" className={`one wide ${ScmModuleStyle.wide}`}>
                              {summaryReports?.GeneralFeedback?.last_CustomerMorals?.Q3}
                            </td>
                            <td headers="prevQ4 prevAttempt" className={`one wide ${ScmModuleStyle.wide} ${ScmModuleStyle["border-right"]}`}>
                              {summaryReports?.GeneralFeedback?.last_CustomerMorals?.Q4}
                            </td>
                          </>
                        ) : null }
                        <td headers="currQ1 currAttempt" className={`one wide ${ScmModuleStyle.wide}`}>
                          {summaryReports?.GeneralFeedback?.CustomerMorals?.Q1}
                        </td>
                        <td headers="currQ2 currAttempt" className={`one wide ${ScmModuleStyle.wide}`}>
                          {summaryReports?.GeneralFeedback?.CustomerMorals?.Q2}
                        </td>
                        <td headers="currQ3 currAttempt" className={`one wide ${ScmModuleStyle.wide}`}>
                          {summaryReports?.GeneralFeedback?.CustomerMorals?.Q3}
                        </td>
                        <td headers="currQ4 currAttempt" className={`one wide ${ScmModuleStyle.wide}`}>
                          {summaryReports?.GeneralFeedback?.CustomerMorals?.Q4}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                </tr>
                <tr>
                  <td className={`${ScmModuleStyle["text-td"]}`} colSpan={summaryReports?.GeneralFeedback?.last_totalComponent1Cost !== "NA" ? 3 : 2 }>
                      {summaryReports?.GeneralFeedback?.CustomerMoralVedict}
                  </td>
                </tr>
                <tr>
                  <th id="cnclOdr"
                    colSpan={summaryReports?.GeneralFeedback != undefined && summaryReports?.GeneralFeedback?.last_totalComponent1Cost !== "NA" ? 3 : 2 }
                    className={`${ScmModuleStyle["row-heading"]}`}
                  >
                    Canceled Orders
                  </th>
                </tr>
                <tr className={`${ScmModuleStyle["indent-row"]}`}>
                  <th id="odrCnclCnt" headers="cnclOdr"
                    className={`eight wide ${ScmModuleStyle.eight} ${ScmModuleStyle.wide}`}
                  >
                    Orders Canceled Count
                  </th>
                  {summaryReports?.GeneralFeedback?.last_cancelOrders !=
                    "NA" ? (
                    <td headers="cnclOdr odrCnclCnt prevAttempt"
                      className={`four wide right aligned ${ScmModuleStyle.four} ${ScmModuleStyle.wide} ${ScmModuleStyle.right} ${ScmModuleStyle.aligned}`}
                    >
                      {summaryReports?.GeneralFeedback?.last_cancelOrders}
                    </td>
                  ) : null }
                  <td headers="cnclOdr odrCnclCnt currAttempt"
                    className={`four wide right aligned ${ScmModuleStyle.four} ${ScmModuleStyle.wide} ${ScmModuleStyle.right} ${ScmModuleStyle.aligned}`}
                  >
                    {summaryReports?.GeneralFeedback?.cancelOrders}
                  </td>
                </tr>
                <tr>
                  <td className={`${ScmModuleStyle["text-td"]}`} colSpan={summaryReports?.GeneralFeedback?.last_totalComponent1Cost !== "NA" ? 3 : 2 }>
                    {summaryReports?.GeneralFeedback?.CancelOrdersVedict}
                  </td>
                </tr>
                <tr>
                  <th id="msgNotfcn"
                    colSpan={summaryReports?.GeneralFeedback != undefined && summaryReports?.GeneralFeedback?.last_totalComponent1Cost !== "NA" ? 3 : 2 }
                    className={`${ScmModuleStyle["row-heading"]}`}
                  >
                    Messages and Notifications
                  </th>
                </tr>
                <tr>
                  <td headers="msgNotfcn" className={`${ScmModuleStyle["text-td"]}`} colSpan={summaryReports?.GeneralFeedback?.last_totalComponent1Cost !== "NA" ? 3 : 2 }>
                      {summaryReports?.GeneralFeedback?.ReadArtifact}
                      {summaryReports?.GeneralFeedback?.RemaingArtifactVedict}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            className={`${ScmModuleStyle.section} ${ScmModuleStyle["financial-analysis-div"]}`}
            id={`${ScmModuleStyle.financialAnalysis}`}
          >
            <h2
              className={`ui header ${ScmModuleStyle.ui} ${ScmModuleStyle.header}`}
            >
              Financial Analysis
            </h2>
            <p>{summaryReports?.FinancialAnalysis?.ProfitGoal}</p>
            <div
              className={`ui stackable two column grid ${ScmModuleStyle.ui} ${ScmModuleStyle.stackable} ${ScmModuleStyle.column} ${ScmModuleStyle.grid} ${ScmModuleStyle["financialAnalysis-container"]}`}
            >
              <div
                className={`column ${ScmModuleStyle.column} ${ScmModuleStyle["table-block"]}`}
              >
                <table
                  className={`ui unstackable table ${ScmModuleStyle.ui} ${ScmModuleStyle.unstackable} ${ScmModuleStyle.table}`}
                >
                  <tbody>
                    <tr>
                      <td>Total order cost for SKU1</td>
                      <td>
                        {checkNum(
                          Number(
                            summaryReports?.FinancialAnalysis
                              ?.totalComponent1Cost
                          )
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>+ Total order cost for SKU2</td>
                      <td>
                        {checkNum(
                          Number(
                            summaryReports?.FinancialAnalysis
                              ?.totalComponent2Cost
                          )
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>+ Total Bid Cost</td>
                      <td>
                        {checkNum(
                          Number(
                            summaryReports?.FinancialAnalysis
                              ?.totalBidRequestCost
                          )
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Total Procurement Cost</strong>
                      </td>
                      <td>
                        <strong>
                          {checkNum(
                            Number(
                              summaryReports?.FinancialAnalysis
                                ?.totalProcurementCost
                            )
                          )}
                        </strong>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={2}>
                        <hr aria-hidden="true" role="presentation"></hr>
                      </td>
                    </tr>
                    <tr>
                      <td>Total Budget</td>
                      <td>
                        {checkNum(
                          summaryReports?.FinancialAnalysis?.totalBudget
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>- Total Procurement Cost</td>
                      <td>
                        {checkNum(
                          Number(
                            summaryReports?.FinancialAnalysis
                              ?.totalProcurementCost
                          )
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>Remaining Budget</td>
                      <td>
                        {checkNum(
                          summaryReports?.FinancialAnalysis?.remainingBudget
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={2}>
                        <hr aria-hidden="true" role="presentation"></hr>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Remaining Budget(%)</strong>
                      </td>
                      <td>
                        <strong>
                          {
                            summaryReports?.FinancialAnalysis
                              ?.remainingBudgetperc
                          }
                          %
                        </strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                className={`column ${ScmModuleStyle.column} ${ScmModuleStyle["graph-block"]}`}
              >
                <div className={`${ScmModuleStyle["expense-breakdown-graph"]}`}>
                  <GraphPerQuarter
                    summaryReports={summaryReports}
                    id={"QuarterFinancialAnalysis"}
                    height={400}
                    title={"Expense Breakdown Chart"}
                    series1={"Budget"}
                    series2={"Actual Spendings"}
                    yAxisTitle={"Money Spent"}
                  />
                  <div className={`${ScmModuleStyle['Quarters-legends']}`}>
                  <div className={`${ScmModuleStyle['EB-Quarter1']}`}><span className={`${ScmModuleStyle['Quarterspattern']}`} aria-hidden="true" role="presentation"><div className={`${ScmModuleStyle['Quarter-legend-sign1']}`}></div></span>Budget</div>
                  <div className={`${ScmModuleStyle['EB-Quarter2']}`}><span className={`${ScmModuleStyle['Quarterspattern']}`} aria-hidden="true" role="presentation"><div className={`${ScmModuleStyle['Quarter-legend-sign2']}`}></div></span>Actual Spendings</div>
                </div>
                </div>
              </div>
            </div>
            <div
              className={`ui stackable two column grid ${ScmModuleStyle.ui} ${ScmModuleStyle.stackable} ${ScmModuleStyle.column} ${ScmModuleStyle.grid} ${ScmModuleStyle["financialAnalysis-container"]}  ${ScmModuleStyle["mgTop-SKUs"]}`}
            >
              <div
                className={`column ${ScmModuleStyle.column} ${ScmModuleStyle["graph-block"]}`}
              >
                <div className={`${ScmModuleStyle["sku2-breakdown-graph"]}`}>
                  <GraphProcurementBreakdown
                    summaryReports={summaryReports}
                    id={"SKU1"}
                    title={"SKU1 Procurement Breakdown Chart"}
                    gColor={"#005A70"}
                    xAxistitle={"SKU1 Supplier Name"}
                  />
                  <div className={`${ScmModuleStyle['ProcurementCost-legends']}`}>
                  <div className={`${ScmModuleStyle['ProcurementBreak']}`}><span className={`${ScmModuleStyle['ProcurementCostpattern']}`} aria-hidden="true" role="presentation"><div className={`${ScmModuleStyle['SKU1-sign1']}`}></div></span>Order Cost</div>
                </div>
                </div>
              </div>
              <div
                className={`column ${ScmModuleStyle.column} ${ScmModuleStyle["graph-block"]}`}
              >
                <div className={`${ScmModuleStyle["sku2-breakdown-graph"]}`}>
                  <GraphProcurementBreakdown
                    summaryReports={summaryReports}
                    id={"SKU2"}
                    title={"SKU2 Procurement Breakdown Chart"}
                    gColor={"#D46719"}
                    xAxistitle={"SKU2 Supplier Name"}
                  />
                  <div className={`${ScmModuleStyle['ProcurementCost-legends']}`}>
                  <div className={`${ScmModuleStyle['ProcurementBreak']}`}><span className={`${ScmModuleStyle['ProcurementCostpattern']}`} aria-hidden="true" role="presentation"><div className={`${ScmModuleStyle['SKU2-sign2']}`}></div></span>Order Cost</div>
                </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`${ScmModuleStyle.section} ${ScmModuleStyle["decision-analysis-div"]}`}
            id={`${ScmModuleStyle.decisionAnalysis}`}
          >
            <h2
              className={`ui header ${ScmModuleStyle.ui} ${ScmModuleStyle.header}`}
            >
              Decision Analysis
            </h2>
            <div
              className={`ui stackable two column grid ${ScmModuleStyle.ui} ${ScmModuleStyle.stackable} ${ScmModuleStyle.column} ${ScmModuleStyle.grid} ${ScmModuleStyle["financialAnalysis-container"]}`}
            >
              <div
                className={`column ${ScmModuleStyle.column} ${ScmModuleStyle["graph-block"]}`}
              >
                <div className={`${ScmModuleStyle["gizmos-graph"]}`}>
                  <GraphPerQuarter
                    summaryReports={summaryReports}
                    id={"QuarterDecisionAnalysis"}
                    height={440}
                    title={`${(summaryReports?.userData && summaryReports?.userData!="") ? getUserData(summaryReports?.userData,2).charAt(0).toUpperCase() + getUserData(summaryReports?.userData,2).slice(1) : "Gizmos"} Manufactured Per Quarter`}
                    series1={"Target"}
                    series2={"Manufactured"}
                    yAxisTitle={`${(summaryReports?.userData && summaryReports?.userData!="") ? getUserData(summaryReports?.userData,2).charAt(0).toUpperCase() + getUserData(summaryReports?.userData,2).slice(1) : "Gizmos"} Manufactured`}
                  />
                  <div className={`${ScmModuleStyle['Quarters-legends']}`}>
                  <div className={`${ScmModuleStyle['EB-Quarter1']}`}><span className={`${ScmModuleStyle['Quarterspattern']}`} aria-hidden="true" role="presentation"><div className={`${ScmModuleStyle['Quarter-legend-sign1']}`}></div></span>Target</div>
                  <div className={`${ScmModuleStyle['EB-Quarter2']}`}><span className={`${ScmModuleStyle['Quarterspattern']}`} aria-hidden="true" role="presentation"><div className={`${ScmModuleStyle['Quarter-legend-sign2']}`}></div></span>Manufactured</div>
                </div>
                </div>
              </div>
              <div
                className={`column ${ScmModuleStyle.column} ${ScmModuleStyle["graph-block"]}`}
              >
                <div className={`${ScmModuleStyle["supplier-graph"]}`}>
                  <OrderBySupplierGraph summaryReports={summaryReports} />
                </div>
              </div>
            </div>
            <div className={`${ScmModuleStyle["quarterly-div"]}`}>
              <h3>Quarterly Status</h3>
              <div className={`${ScmModuleStyle["decision-tbl-container"]}`}>
                <table className={`ui celled unstackable table ${ScmModuleStyle.ui} ${ScmModuleStyle.celled} ${ScmModuleStyle.unstackable} ${ScmModuleStyle.table} ${ScmModuleStyle["quarterly-tbl"]}`}>
                  <thead>
                    <tr>
                      <th>Status</th>
                      <th>Quarter 1</th>
                      <th>Quarter 2</th>
                      <th>Quarter 3</th>
                      <th>Quarter 4</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Budget Spent Status</td>
                      <td>
                        {summaryReports?.DecisionAnalysis?.decisionAccuracy?.Q1?.BudgetSpentStatus}
                      </td>
                      <td>
                        {summaryReports?.DecisionAnalysis?.decisionAccuracy?.Q2?.BudgetSpentStatus}
                      </td>
                      <td>
                        {summaryReports?.DecisionAnalysis?.decisionAccuracy?.Q3?.BudgetSpentStatus}
                      </td>
                      <td>
                        {summaryReports?.DecisionAnalysis?.decisionAccuracy?.Q4?.BudgetSpentStatus}
                      </td>
                    </tr>
                    <tr>
                      <td>{(summaryReports?.userData && summaryReports?.userData!="") ? getUserData(summaryReports?.userData,2).charAt(0).toUpperCase() + getUserData(summaryReports?.userData,2).slice(1) : "Gizmos"} Manufacturing Goal Status</td>
                      <td>
                        {summaryReports?.DecisionAnalysis?.decisionAccuracy?.Q1?.GizmosGoalStatus}
                      </td>
                      <td>
                        {summaryReports?.DecisionAnalysis?.decisionAccuracy?.Q2?.GizmosGoalStatus}
                      </td>
                      <td>
                        {summaryReports?.DecisionAnalysis?.decisionAccuracy?.Q3?.GizmosGoalStatus}
                      </td>
                      <td>
                        {summaryReports?.DecisionAnalysis?.decisionAccuracy?.Q4?.GizmosGoalStatus}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className={`${ScmModuleStyle["order-div"]}`}>
              <h3>Order Breakdown</h3>
              <div className={`${ScmModuleStyle["order-tbl-container"]}`}>
                <table className={`ui unstackable table ${ScmModuleStyle.ui} ${ScmModuleStyle.unstackable} ${ScmModuleStyle.table} ${ScmModuleStyle["order-tbl"]}`}>
                  <thead>
                    <tr>
                      <th id="sName">Supplier Name</th>
                      <th id="cPrUnt">Cost Per Unit</th>
                      <th id="wRDlvry">Weekly Delivery / Rush Delivery</th>
                      <th id="oQnty">Order Quantity</th>
                      <th id="oCost">Order Cost</th>
                      <th id="dDate">Delivery Date</th>
                      <th id="dStatus">Delivery Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th colSpan={7} className={`${ScmModuleStyle["row-heading"]}`}>
                        SKU1
                      </th>
                    </tr>
                    { summaryReports?.supplierDetails != undefined && summaryReports?.DecisionAnalysis?.supplierOrderHistory?.map(
                      (suppOrderObj, index) => 
                      (suppOrderObj?.component1Unit != 0) ? (
                          <tr className={`${ScmModuleStyle["indent-row"]}`}>
                            <td headers="sName" key={index}>
                              <strong>{suppOrderObj?.supplierName}</strong>
                            </td>
                            <td headers="cPrUnt">
                              <ul>
                                {suppOrderObj?.priceQuantityDetailList.map(
                                  (priceDetailObj, index) => (
                                    <li>
                                      <span key={index}>
                                        {formatNum(priceDetailObj?.minNumberofUnits)} - {" "}
                                        {formatNum(priceDetailObj?.maxNumberofUnits)}
                                      </span>
                                      <span key={index}>
                                        ${priceDetailObj?.costPerUnit}
                                      </span>
                                    </li>
                                  )
                                )}
                              </ul>
                            </td>
                            <td headers="wRDlvry">
                              {
                                summaryReports?.supplierDetails[suppOrderObj.supplierId]
                                  ?.supplierUnitsPerWeek
                              }{" "}
                              /{" "}
                              {
                                summaryReports?.supplierDetails[suppOrderObj.supplierId]
                                  ?.supplierExpediteUnitsPerWeek
                              }
                            </td>
                            <td headers="oQnty" key={index}>
                              {suppOrderObj?.component1Unit}
                            </td>
                            <td headers="oCost" key={index}>
                              {checkNum(suppOrderObj?.totalCost)}
                            </td>
                            <td headers="dDate" key={index}>
                              {suppOrderObj?.deliveryDate
                                ? new Date(
                                    suppOrderObj.deliveryDate
                                  ).toLocaleDateString("en-US")
                                : ""}
                            </td>
                            <td
                              headers="dStatus"
                              key={index}
                              style={{
                                color: `${
                                  suppOrderObj?.orderStatus == "CANCELLED"
                                    ? "rgb(185, 0, 0)"
                                    : "green"
                                }`,
                              }}
                            >
                              <strong>{suppOrderObj?.orderStatus}</strong>
                            </td>
                          </tr>
                        ) : (
                          ""
                        )
                    )}
                    <tr>
                      <th colSpan={7} className={`${ScmModuleStyle["row-heading"]}`}>
                        SKU2
                      </th>
                    </tr>
                    {summaryReports?.supplierDetails != undefined && summaryReports?.DecisionAnalysis?.supplierOrderHistory?.map(
                      (suppOrderObj, index) =>
                      (suppOrderObj?.component2Unit != 0)  ? (
                          <tr className={`${ScmModuleStyle["indent-row"]}`}>
                            <td headers="sName" key={index}>
                              <strong>{suppOrderObj?.supplierName}</strong>
                            </td>
                            <td headers="cPrUnt">
                              <ul>
                                {suppOrderObj?.priceQuantityDetailList.map(
                                  (priceDetailObj, index) => (
                                    <li>
                                      <span key={index}>
                                        {formatNum(priceDetailObj?.minNumberofUnits)} -{" "}
                                        {formatNum(priceDetailObj?.maxNumberofUnits)}
                                      </span>
                                      <span key={index}>
                                        ${priceDetailObj?.costPerUnit}
                                      </span>
                                    </li>
                                  )
                                )}
                              </ul>
                            </td>
                            <td headers="wRDlvry">
                              {
                                summaryReports?.supplierDetails[suppOrderObj.supplierId]
                                  ?.supplierUnitsPerWeek
                              }{" "}
                              /{" "}
                              {
                                summaryReports?.supplierDetails[suppOrderObj.supplierId]
                                  ?.supplierExpediteUnitsPerWeek
                              }
                            </td>
                            <td headers="oQnty" key={index}>
                              {suppOrderObj?.component2Unit}
                            </td>
                            <td headers="oCost" key={index}>
                              {checkNum(suppOrderObj?.totalCost)}
                            </td>
                            <td headers="dDate" key={index}>
                              {suppOrderObj?.deliveryDate
                                ? new Date(
                                    suppOrderObj.deliveryDate
                                  ).toLocaleDateString("en-US")
                                : ""}
                            </td>
                            <td 
                              headers="dStatus"
                              key={index}
                              style={{
                                color: `${
                                  suppOrderObj?.orderStatus == "CANCELLED"
                                    ? "rgb(185, 0, 0)"
                                    : "green"
                                }`,
                              }}
                            >
                              <strong>{suppOrderObj?.orderStatus}</strong>
                            </td>
                          </tr>
                        ) : (
                          ""
                        )
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className={`${ScmModuleStyle["summary-footer"]}`}>
          {!(attempt != undefined && user_id != undefined) && (
            <div className={`${ScmModuleStyle["summary-btn-container"]}`}>
              <Button
                btnName="BACK TO SIMULATION"
                btnId="backToSimulationBtn"
                customBtnStyle={summaryBtnStyle}
                clickEventHandler={navigateToSimulation}
              />
              {summaryReports.nextattempt ? (
                <Button
                  btnName="START OVER"
                  btnId="startOverBtn"
                  customBtnStyle={summaryBtnStyle}
                  clickEventHandler={startOverSimulation}
                />
              ) : (
                <span style={{ display: "flex" }}>
                  <img src={info} alt="info" style={{"height":"14px","width":"14px","margin-top":"6px"}} />
                  <em>You do not have any remaining attempts.</em>
                </span>
              )}
              <Button
                btnName="DONE"
                btnId="doneBtn"
                customBtnStyle={summaryBtnStyle}
                clickEventHandler={handlePopupExitSim}
              />
            </div>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default Summary;
